import React from "react";
import _ from "lodash";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import rem from "../utils/rem";
import IncidentForm from "../components/IncidentForm";
import GameIncidentUpdatesTable from "../components/GameIncidentUpdatesTable";
import IncidentMetadata from "../components/IncidentMetadata";
import BaseChevron from "../components/icons/Chevron";

const Wrapper = styled.div`
  margin: ${rem(30)};
  width: 1330px;
`;

const IncidentNameWrapper = styled.div`
  padding: ${rem(20)} 0;
  font-size: ${rem(20)};
`;

const GameSlug = styled.div`
  font-size: ${rem(26)};
  font-weight: 500;
`;

const Chevron = BaseChevron``;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const FlexItem = styled.div`
  flex: ${props => props.flex};
  align-self: flex-end;
`;

const FormExpander = styled.div`
  cursor: pointer;
  margin: 20px 0;
`;

class ViewIncident extends React.Component {
  constructor(props) {
    super(props);

    this.state = { showForm: false };
  }

  componentDidMount() {
    const { limboStore: store } = this.props.rootStore;
    const { params } = this.props.match;

    store.fetchIncident(params.id);
  }

  render() {
    const { limboStore: store, authStore } = this.props.rootStore;
    const { showForm } = this.state;
    const incident = store.singleIncident;
    const canEdit = authStore.hasLimboEdit;

    // TODO: Proper loading
    if (_.isEmpty(incident)) {
      return null;
    }

    return (
      <Wrapper>
        <h1>Data Quality Report - Incident - #{incident.id}</h1>
        <GameSlug>
          {incident.systemWide ? "System Wide Incident" : incident.gamePk}
        </GameSlug>
        <IncidentNameWrapper>{incident.name}</IncidentNameWrapper>
        <IncidentMetadata incident={incident} />
        <hr />
        <FlexContainer>
          <FlexItem>
            <h2>Incident History</h2>
          </FlexItem>
          {canEdit ? (
            <FlexItem>
              <FormExpander
                onClick={() => {
                  this.setState(prevState => {
                    const { showForm } = prevState;
                    return { showForm: !showForm };
                  });
                }}
              >
                <Chevron direction={showForm ? "up" : "down"} /> Update Incident
              </FormExpander>
            </FlexItem>
          ) : null}
        </FlexContainer>
        {showForm ? (
          <IncidentForm
            onSubmit={store.createIncidentUpdate}
            afterSubmit={() =>
              store.fetchIncident(incident.id).then(() => {
                this.setState({ showForm: false });
              })
            }
            isEditing
            previousIncident={incident}
          />
        ) : null}
        <GameIncidentUpdatesTable incident={incident} />
      </Wrapper>
    );
  }
}

export default withRouter(inject("rootStore")(observer(ViewIncident)));



// WEBPACK FOOTER //
// ./src/containers/ViewIncident.js